import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";

/** The latest update check, shown on Preferences › Updates. */
export type DesktopUpdateCheck =
  | { status: "checking" }
  | { status: "up-to-date" }
  | { status: "available"; version: string }
  | { status: "failed" };

interface DesktopUpdateState {
  readyVersion: string | null;
  isInstalling: boolean;
  lastCheck: DesktopUpdateCheck | null;
  setReadyVersion: (version: string | null) => void;
  setInstalling: (installing: boolean) => void;
  setLastCheck: (check: DesktopUpdateCheck | null) => void;
  clearReady: () => void;
}

export const useDesktopUpdateStore = create<DesktopUpdateState>()(
  mirroredStore("desktopUpdate", (set) => ({
    readyVersion: null,
    isInstalling: false,
    lastCheck: null,
    setReadyVersion: (version) => set({ readyVersion: version }),
    setInstalling: (installing) => set({ isInstalling: installing }),
    setLastCheck: (lastCheck) => set({ lastCheck }),
    clearReady: () => set({ readyVersion: null, isInstalling: false }),
  })),
);
